import Joi from 'joi';

const details = {
  name: Joi.string()
    .label('Schema Name')
    .min(3)
    .max(100)
    .required(),
  option: Joi.string()
    .label('Integration Products')
    .required()
};

const eventTypeValidation = Joi.array()
  .items(
    Joi.object({
      eventTypeIdentifierValue: Joi.string()
        .label('eventTypeIdentifierValue')
        .required(),
      eventTypeGroup : Joi.string()
        .label('eventTypeGroup ')
        .required(),
      eventTypeSchema: Joi.string()
        .label('eventTypeSchema')
        .required()
    })
  )
  .min(1)
  .message('"eventTypeGroup" must have at least 1 eventType configured');

const enrichmentDataValidation = Joi.array()
  .items(
    Joi.object({
      enrichmentProduct: Joi.string()
        .label('enrichmentProduct')
        .required(),
      enrichmentProductUuidPath: Joi.string()
        .label('enrichmentProductUuidPath')
        .required(),
      schemaEnrichmentUuid: Joi.string()
        .label('schemaEnrichmentUuid')
        .required()
    })
  );

const design = {
  schemaToEventPartialCollectionName: Joi.string()
    .label('schemaToEventPartialCollectionName')
    .required(),
  businessContextId: Joi.string()
    .label('businessContextId')
    .required(),
  eventProductCategory: Joi.string()
    .label('eventProductCategory')
    .required(),
  eventProductName: Joi.string()
    .label('eventProductName')
    .required(),
  eventTypeCategory: Joi.string()
    .label('eventTypeCategory')
    .required(),
  schemaName: Joi.string()
    .label('schemaName')
    .min(3)
    .max(100)
    .required(),
  tenantId: Joi.string()
    .label('tenantId')
    .required(),
  eventTypePath: Joi.string()
    .label('eventTypePath')
    .required(),
  eventTypeGroup: eventTypeValidation,
  emailAddressPath: Joi.alternatives().conditional('phoneNumberPath', {
    is: '',
    then: Joi.string().required(),
    otherwise: Joi.string().allow('')
  }),
  phoneNumberPath: Joi.alternatives().conditional('emailAddressPath', {
    is: '',
    then: Joi.string().required(),
    otherwise: Joi.string().allow('')
  }),
  schemaEnrichmentData: Joi.alternatives().conditional('internal', {
    is: false,
    then: enrichmentDataValidation,
    otherwise: Joi.any()
  })
};

export default {
  details,
  design
};
